import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  Card, CardHeader, CardContent,
} from '@material-ui/core';
import { Collapse } from '@mui/material';
import { noop } from 'Helpers/PropTypes';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import classNames from 'classnames';

const useStyles = buildUseStyles('CollapsibleCard', (theme) => ({
  root: {
    width: '100%',
    boxShadow: 'rgba(0, 0, 0, 0.06) 0px 4px 20px',
    borderRadius: 13,
    cursor: 'pointer',
  },
  title: {
    fontWeight: theme.typography.fontWeightFacetMedium,
  },
  subtitle: {
    transition: 'opacity 0.25s linear',
  },
  hidden: {
    opacity: 0,
  },
  cardContent: {
    paddingTop: theme.spacing(0),
  },
  headerAction: {
    margin: theme.spacing(0, 0, 0, 1),
    alignSelf: 'center',
  },
  carat: {
    color: theme.palette.facet.primaryGray,
    transition: 'transform 307ms ease-out',
  },
  rotate180: {
    transform: 'rotate(180deg)',
  },
  blue: {
    backgroundColor: theme.palette.facet.accentBlue20,
  },
  default: {
    backgroundColor: theme.palette.common.white,
  },
}));

const CollapsibleCard = ({
  className,
  test,
  title,
  subtitle,
  children,
  onClick,
  appearance,
  defaultExpanded,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleClick = () => {
    onClick();
    setExpanded(!expanded);
  };

  return (
    <Card
      className={classNames(className, classes.root, {
        [classes.default]: appearance === 'default',
        [classes.blue]: appearance === 'blue',
      })}
      test={test}
    >
      <CardHeader
        classes={{
          action: classes.headerAction,
        }}
        title={title}
        titleTypographyProps={{
          className: classes.title,
          variant: 'h5',
        }}
        subheader={subtitle}
        subheaderTypographyProps={{
          className: classNames(classes.subtitle, { [classes.hidden]: expanded }),
        }}
        onClick={handleClick}
        action={
          <ArrowDropDownIcon className={classNames(classes.carat, { [classes.rotate180]: expanded })} />
        }
      />
      <Collapse in={expanded} timeout={'auto'}>
        <CardContent className={classes.cardContent}>
          {children}
        </CardContent>
      </Collapse>
    </Card>
  );
};

CollapsibleCard.defaultProps = {
  className: '',
  test: undefined,
  children: null,
  onClick: noop,
  appearance: 'default',
  subtitle: '',
  defaultExpanded: false,
};

CollapsibleCard.propTypes = {
  className: PropTypes.string,
  test: PropTypes.string,
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  onClick: PropTypes.func,
  appearance: PropTypes.string,
  defaultExpanded: PropTypes.bool,
};

export default CollapsibleCard;
